<template>
  <ppt-modal class="five-card-hand-weight-modal">
    <header slot="header">
      <button class="close" data-dismiss="modal"><span>&times;</span></button>
      <h4 v-if="fiveCardHand" class="modal-title" v-html="fiveCardHand.text"></h4>
    </header>
    <section slot="body">
      <section v-if="fiveCardHand && fiveCardHand.visible">
        <!-- not checked -->
        <p v-if="!fiveCardHand.checked">
          You can't set the weight of checkboxes that aren't checked.
        </p>

        <!-- parent -->
        <section v-else-if="fiveCardHand.children">
          <p>Set weight of all children:</p>
          <vue-slider
            ref="sliderParent"
            v-model="fiveCardHandParentWeight"
            v-bind="vueSliderOptions"
          ></vue-slider>
          <hr>
          <button
            class="btn btn-default btn-block"
            v-on:click="applyExactWeightToFiveCardHand(fiveCardHand, $refs.sliderParent.value)"
          >
            Apply
          </button>
          <br>
          <p>Example use case: if you think that opponents would only continue with their flush draws 75% of the time rather than 100% of the time.</p>
        </section>

        <!-- leaf -->
        <section v-else>
          <p>Set weight:</p>
          <vue-slider
            ref="sliderLeaf"
            v-model="fiveCardHandLeafWeight"
            v-bind="vueSliderOptions"
            v-on:callback="$emit('updateWeightOfFiveCardHand', { fiveCardHandId: fiveCardHand.id, newWeight: $event })"
          ></vue-slider>
          <hr>
          <p>Example use case: if you think that opponents would continue with their gutshots 25% of the time rather than 0% of the time.</p>
        </section>
      </section>
    </section>
  </ppt-modal>
</template>

<script>
import PPTModal from '@/components/utilities/modal';
import VueSlider from 'vue-slider-component';
import utilities from '@/services/utilities/utilities';

export default {
  name: 'five-card-hand-weight-modal',
  components: {
    'ppt-modal': PPTModal,
    'vue-slider': VueSlider,
  },
  props: ['fiveCardHand'],
  data: function () {
    return {
      fiveCardHandParentWeight: 100,
      fiveCardHandLeafWeight: 100,
      vueSliderOptions: {
        min: 5,
        interval: 5,
      },
    };
  },
  mounted: function () {
  	let self = this;

  	$(this.$el).on('shown.bs.modal', function () {
      self.$nextTick(function () {
        let weight;

        if (self.fiveCardHand && self.fiveCardHand.hasExplicitWeight) {
          weight = self.fiveCardHand.weight;
        } else {
          weight = 100;
        }

        if (self.$refs.sliderParent) {
          self.$refs.sliderParent.refresh();
          self.$refs.sliderParent.setValue(weight);
        }

        if (self.$refs.sliderLeaf) {
          self.$refs.sliderLeaf.refresh();
          self.$refs.sliderLeaf.setValue(weight);
        }
      });
    });
  },
  methods: {
    applyExactWeightToFiveCardHand: function (fiveCardHand, newWeight) {
      this.$emit('applyExactWeightToFiveCardHand', {
        fiveCardHand: fiveCardHand,
        newWeight: newWeight,
      });
      $(this.$el).modal('hide');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/five-card-hands-section/five-card-hand-weight-modal.vue